<template>
  <div>
    <el-alert type="info" show-icon title="Under Development" description="Still under testing not everything is working yet." />
    <h4>Revenue</h4>
    <br />
    <site-revenue-add  v-if="isManager('finance')" :renewals="renewals" :site-id="site.id" @update="addRenewal" />

    <br />
    <site-revenue-statement :renewals="renewals" />

  </div>

</template>


<script>

import SiteMixins from '@/mixins/SiteMixins'

import SiteRevenueAdd from '@/components/sites/finance/revenue/SiteRevenueAdd'
import SiteRevenueStatement from '@/components/sites/finance/revenue/SiteRevenueStatement'

export default {

  mixins: [SiteMixins],

  components: {
    SiteRevenueAdd,
    SiteRevenueStatement
  },


  props: {

    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    }

  },


  methods: {
    addRenewal (array) {
      this.renewals = array
    }
  },


  data () {

    return {
      site: this.rowData,
      renewals: []
    }

  }

}
</script>
